import script from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInput.vue?vue&type=style&index=0&id=73e9d3a6&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e9d3a6"]])

export default __exports__